import React from 'react';
import {
  useLoaderData,
  useAwaited,
} from '@tanstack/react-router';

import DashboardShareItem from './ShareItem';

import type { Memory } from '../../types/memory';
import type { Share } from '../../types/share';

const DashboardShares: React.FC<{ memory: Memory }> = ({ memory }) => {
  const { shares } = useLoaderData({ strict: false });
  const sharesData = useAwaited<Share[]>({ promise: shares });

  if (!memory) {
    return null;
  }

  return (
    <div className="dashboard-shares">
      <div className="dashboard-shares-list wa-stack wa-gap-0 inner">
        <div className="dashboard-header page-header">
          <div className="page-eyebrow">
            Sent shares
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th>E-mail</th>
              <th>Name</th>
              <th>Comment</th>
              <th>Sent at</th>
              <th>First view at</th>
            </tr>
          </thead>
          <tbody>
            {sharesData.map((share) => (
              <DashboardShareItem key={share.short_code} share={share} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DashboardShares;
